import React from 'react';
import { 
  FaUsers, FaLeaf, FaStoreAlt, FaChartLine, FaTruck, 
  FaDoorOpen, FaCreditCard, FaEuroSign, FaFileInvoice,
  FaClipboardCheck
} from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaUsers />,
      title: 'Gestión de Socios',
      description: 'Control completo de socios: altas, bajas, renovaciones, documentación, avales y seguimiento del estado de cada socio.',
      features: ['Altas y bajas', 'Control de avales', 'Gestión documental', 'Vencimientos automáticos']
    },
    {
      icon: <FaLeaf />,
      title: 'Control de Stock Cannabis',
      description: 'Gestión avanzada de genéticas y productos cannábicos por categorías (Sativa, Indica, Híbrida, CBD, Resinas, Joints, BHO, Hash).',
      features: ['Stock en tiempo real', 'Cuadre automático', 'Historial movimientos', 'Alertas de stock bajo']
    },
    {
      icon: <FaStoreAlt />,
      title: 'Dispensario Cannábico',
      description: 'Sistema profesional de dispensación con identificación de socios, control de cantidades, descuentos y métodos de pago.',
      features: ['Retiradas rápidas', 'Múltiples métodos de pago', 'Descuentos automáticos', 'Historial por socio']
    },
    {
      icon: <FaChartLine />,
      title: 'Gestión de Aportaciones',
      description: 'Registro completo de todas las aportaciones del club: cannabis, bebidas, comida, merchandising y membresías.',
      features: ['Aportaciones por tipo', 'Estadísticas diarias', 'Top usuarios', 'Exportación PDF/CSV']
    },
    {
      icon: <FaTruck />,
      title: 'Proveedores',
      description: 'Control profesional de proveedores con gestión de deuda, historial de compras, pagos y liquidaciones.',
      features: ['Control de deuda', 'Historial compras', 'Pagos parciales/totales', 'Días de pago']
    },
    {
      icon: <FaDoorOpen />,
      title: 'Control de Acceso',
      description: 'Registro de entradas y salidas de socios con control de aforo en tiempo real y visualización de quién está dentro.',
      features: ['Check-in/Check-out', 'Aforo en tiempo real', 'Historial de visitas', 'Estadísticas de acceso']
    },
    {
      icon: <FaCreditCard />,
      title: 'Gestión de Membresías',
      description: 'Control automatizado de cuotas de socios con diferentes planes, cobros y renovaciones automáticas.',
      features: ['Planes personalizados', 'Cobros automáticos', 'Alertas vencimiento', 'Historial de pagos']
    },
    {
      icon: <FaEuroSign />,
      title: 'Contabilidad Completa',
      description: 'Sistema integral de gestión financiera: facturación, gastos, gastos fijos mensuales y control de deuda con socios.',
      features: ['Facturación', 'Control de gastos', 'Gastos fijos mensuales', 'Balance automático']
    },
    {
      icon: <FaFileInvoice />,
      title: 'Informes Profesionales',
      description: 'Generación automática de informes financieros, de stock, aportaciones y estadísticas con exportación a PDF.',
      features: ['Informes financieros', 'Informe de stock', 'Informe de aportaciones', 'Exportación PDF']
    },
    {
      icon: <FaClipboardCheck />,
      title: 'Multi-usuario',
      description: 'Sistema de usuarios con diferentes roles y permisos, permitiendo trabajo colaborativo seguro.',
      features: ['Roles de usuario', 'Permisos granulares', 'Auditoría de acciones', 'Gestión segura']
    }
  ];

  return (
    <section id="servicios" className="services gray">
      <div className="container">
        <h2 className="section-title">
          Funcionalidades <span className="highlight">Completas</span>
        </h2>
        <p className="section-subtitle">
          Todo lo que necesitas para gestionar tu club cannábico de forma profesional,
          segura y eficiente en una sola plataforma.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>
                    <span className="feature-bullet">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

